module.exports = __webpack_public_path__ + "media/images/flags/1x1/est-b0ece3430f24b31c59f88c374187a183.svg";